import React from 'react';
import './ExpenseForm.css';
import CustomSelect from '../CustomSelect/CustomSelect';
import AmountInput from '../AmountInput/AmountInput';
import { useExpenseForm } from './useExpenseForm';

const ExpenseForm = ({ onAdd, onSuccess }) => {
  const {
    formData,
    isSubmitting,
    categories,
    notionOptions,
    loadingNotionOptions,
    databases,
    loadingDatabases,
    databaseDisplayValue,
    handleSubmit,
    handleInputChange
  } = useExpenseForm({ onAdd, onSuccess });

  return (
    <div className="expense-form-container">
      <div className="expense-form-card">
        <h2 className="form-title">+ Добавить расход</h2>
        
        <form className="expense-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Статья расходов</label>
            <CustomSelect
              name="category"
              value={formData.category}
              onChange={handleInputChange}
              options={categories}
              placeholder="Выберите статью или введите новую"
              required
              creatable
            />
          </div>

          <div className="form-group">
            <label className="form-label">Исполнитель</label>
            <CustomSelect
              name="executor"
              value={formData.executor}
              onChange={handleInputChange}
              options={notionOptions}
              placeholder={loadingNotionOptions ? 'Загрузка...' : 'Выберите исполнителя'}
              disabled={loadingNotionOptions}
              required
            />
          </div>
          
          <div className="form-group">
            <label className="form-label">Сумма</label>
            <AmountInput
              name="amount"
              value={formData.amount}
              onChange={handleInputChange}
              placeholder="0"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Комментарий</label>
            <textarea
              name="comment"
              value={formData.comment}
              onChange={handleInputChange}
              className="form-textarea"
              placeholder="Дополнительная информация..."
              rows="3"
            />
          </div>

          <div className="form-group">
            <label className="form-label">База данных</label>
            <CustomSelect
              name="databaseId"
              value={databaseDisplayValue}
              onChange={handleInputChange}
              options={databases}
              placeholder={loadingDatabases ? 'Загрузка...' : 'Выберите базу данных'}
              disabled={loadingDatabases}
              required
              openUp={true}
            />
          </div>

          <button type="submit" className="submit-button" disabled={isSubmitting}>
            {isSubmitting ? 'Отправка...' : 'Добавить расход'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ExpenseForm;
